import { autoRegisterFeature } from '@store/features/factory';

import { thumbsFeedbackFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(thumbsFeedbackFeature);

// Container (primary export for consumers)
export { ThumbsFeedbackContainer as ThumbsFeedback } from './components/ThumbsFeedbackContainer';

// Types
export type {
  ThumbsFeedbackCategory,
  ThumbsFeedbackContainerProps,
  ThumbsFeedbackExpandMode,
  ThumbsFeedbackMode,
  ThumbsFeedbackValue,
} from './types';

// Constants (for consumers who want to customize categories)
export { DEFAULT_NEGATIVE_CATEGORIES } from './constants';
